import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import indvImg2 from '../../assets/images/indChatImg2.png';
import { ChatState } from '../../utils/types.ts';

const initialState: ChatState[] = [
  {
    info: 'I need you to send the quotation so that I plan my finances. I will send you the designs tomorrow',
    date: '10/10/2023',
    photo: indvImg2,
  },
  {
    info: 'Okay. Don’t forget the to include the description of the design. I need to deliver the exact results.',
    date: '10/10/2023',
    photo: indvImg2,
  },
  {
    info: 'This is well noted. What help do you need from me?',
    date: '4:30pm',
    photo: indvImg2,
  },
  {
    info: 'Yes, we had talked about transport facilitation.I would like to know more about that.',
    date: '09:00pm',
    photo: indvImg2,
  },
];

const chatSlice = createSlice({
  name: 'chats',
  initialState,
  reducers: {
    addChat(state, action: PayloadAction<ChatState>) {
      state.push(action.payload);
    },
  },
});

export const chatsReducer = chatSlice.reducer;
export const { addChat } = chatSlice.actions;
